import {Iso8601} from '@hconnect/common/types'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

import {MetaAnnotation} from './MetaAnnotation'

type Props = {
  createdOn: Iso8601
  lastModified?: Iso8601
  timezone: string
}

export const MachineSentryActionMetaAnnotations = ({createdOn, lastModified, timezone}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <>
      <MetaAnnotation
        label={t('metaAnnotation.label.created')}
        date={createdOn}
        timezone={timezone}
        data-test-id="meta-annotation-created-on"
      />
      {lastModified && (
        <MetaAnnotation
          label={t('metaAnnotation.label.lastUpdated')}
          date={lastModified}
          timezone={timezone}
          data-test-id="meta-annotation-last-updated"
        />
      )}
    </>
  )
}
